export function addGradeColor(lead: any) {
  const l = {
    ...lead
  };
  if (l.score === 'A+') {
    l.gradeColor = '#32b767';
    l.leadType = 'hot';
    return l;
  }
  if (l.score === 'A') {
    l.gradeColor = '#32b767';
    l.leadType = 'hot';
    return l;
  }
  if (l.score === 'A-') {
    l.gradeColor = '#36cc72';
    l.leadType = 'hot';
    return l;
  }
  if (l.score === 'B+' || l.score === 'B' || l.score === 'B-') {
    l.gradeColor = '#f7bc00';
    l.leadType = 'warm';
    return l;
  }
  if (l.score === 'C+' || l.score === 'C' || l.score === 'C-') {
    l.gradeColor = '#ff9100';
    l.leadType = 'warm';
    return l;
  }
  if (l.score === 'D+' || l.score === 'D' || l.score === 'D-') {
    l.gradeColor = '#f76e2b';
    l.leadType = 'cold';
    return l;
  }

  if (l.score === 'F+' || l.score === 'F' || l.score === 'F-') {
    l.gradeColor = '#ef4343';
    l.leadType = 'cold';
    return l;
  }

  return l;
}

function generateFilteredLeads(leadsList: any[], leadHeatLevel: string): any[] {
  let filteredLeads = leadsList;
  if (leadHeatLevel !== 'all') {
    filteredLeads = filteredLeads.filter(l => {
      if (leadHeatLevel === 'hot') {
        return (
          l.score === 'A+' || l.score === 'A' || l.score === 'A-'
        );
      }
      if (leadHeatLevel === 'warm') {
        return (
          l.score === 'B+' || l.score === 'B' || l.score === 'B-' ||
          l.score === 'C+' || l.score === 'C' || l.score === 'C-'
        );
      }
      if (leadHeatLevel === 'cold') {
        return (
          l.score === 'D+' || l.score === 'D' || l.score === 'D-' ||
          l.score === 'F+' || l.score === 'F' || l.score === 'F-'
        );
      }
      return true;
    });
  }
  filteredLeads = filteredLeads.map(addGradeColor);

  return filteredLeads;
}

export default generateFilteredLeads;
